<script setup lang="ts">
// 导入 ElementPlus 样式及语言包
import '@/styles/init-element-plus.scss';
import 'element-plus/dist/index.css';
// 导入unocss模块
import 'uno.css';

import { isTest, viewWidth } from '@/data/pubilc';

// 导入组件
import LoginDialog from '@/components/content/loginDialog/loginDialog.vue';
import MemberDialog from '@/components/content/memberDialog/memberDialog.vue';
import MessageBox from '@/components/content/MessageBox/MessageBox.vue';
import initConfig from '@/csdPublic/initConfig';
import { allBaseUrl, testList } from './config/apiDomain';
import useStore from '@/stores/publicStore';
import { getStorage } from './utils/storage';
import { clickBodyNode } from '@/data/pubilc';
import { lastStep, step } from '@/views/home/slidePPT/use/data';

// 获取 pinia 数据
const store = useStore();
const { changeUserInfo, changeVipInfo } = store;

const config = {
  soft_id: 'aippt_web',
  os: 1,
  curr_ver: '1.0.0.1',
  wxLoginAndPayDomain: allBaseUrl.qnwApi.url,
  qnwProjectDomain: allBaseUrl.qnwApi.url
};
initConfig(config);

const locale = { name: 'zh-cn' };

const origin = window.location.origin;
if (testList.includes(origin)) {
  isTest.value = true;
}

window.onresize = () => {
  return (() => {
    viewWidth.value = document.body.offsetWidth;
  })();
};

if (getStorage('token')) {
  changeUserInfo();
  changeVipInfo();
}

watch(
  () => step.value,
  (_, o) => {
    lastStep.value = o;
  }
);
</script>

<template>
  <div style="width: 100vw; height: 100vh; overflow: hidden; z-index: 1" @click="clickBodyNode++">
    <el-config-provider :locale="locale">
      <router-view />
    </el-config-provider>
    <LoginDialog />
    <MemberDialog />
    <MessageBox />
  </div>
</template>

<style lang="scss">
@import '@/styles/mixin.scss';
@import '@/styles/icon/iconfont.css';
body {
  overflow: hidden;
}
</style>
